import { createContext } from 'react';

type LoadingContextType = {
  increment: () => void;
  decrement: () => void;
};

export const LoadingContext = createContext<LoadingContextType | null>(null);
